import { render } from "./Payment.vue?vue&type=template&id=21093337"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=21093337&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__